import { axiosWithAuth } from "@/lib/AxiosClient";

export interface Invite {
  id: string;
  invitedOn: string;
  expirationDate: string;
  code: string;
  email: string;
  sentBy: string;
  userIdentifier: string;
}

export class InviteService {
  private static readonly BASE_PATH = "/api/invite"
  private static instance = axiosWithAuth;

  public static async getBySiteId(siteId: string): Promise<Invite[]> {
    const response = await this.instance.get<Invite[]>(`${this.BASE_PATH}/sites/${siteId}`);
    return response.data;
  }

  public static async delete(inviteId: string): Promise<void> {
    await this.instance.delete<void>(`${this.BASE_PATH}/${inviteId}`)
  }

  public static async cancel(inviteId: string): Promise<void> {
    await this.instance.delete<void>(`${this.BASE_PATH}/${inviteId}/cancel`)
  }

  static async createByEmail(email: string, siteId: string): Promise<Invite[]> {
    const response = await this.instance.post<Invite[]>(this.BASE_PATH, { email, siteIds: [siteId] });
    return response.data;
  }

  static async createByCode(code: string, siteId: string): Promise<Invite[]> {
    const response = await this.instance.post<Invite[]>(`${this.BASE_PATH}/code`, { userInviteCode: code, siteIds: [siteId] });
    return response.data;
  }

  static async getActive(): Promise<Invite[]> {
    const response = await this.instance.get<Invite[]>(`${this.BASE_PATH}/active`);
    return response.data;
  }

  static async accept(inviteId: string): Promise<Invite> {
    const response = await this.instance.post<Invite>(`${this.BASE_PATH}/accept/${inviteId}`, { });
    return response.data;
  }
}